import { render, staticRenderFns } from "./datatable_tophist.vue?vue&type=template&id=a36a4076&v-slot%3A=row&"
import script from "./datatable_tophist.vue?vue&type=script&lang=js&"
export * from "./datatable_tophist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
